module.exports = "/assets/data/88f2dfaa020cd566b6deb27c6834b878-SS1.data.json";